document.addEventListener('DOMContentLoaded', () => {

  const footerMenus = document.querySelectorAll('.footer-menu');

  if(window.innerWidth < 768){

    footerMenus.forEach(menu => {

      const heading = menu.querySelector('h3');

      if(!heading) return;

      heading.addEventListener('click', () => {
        menu.classList.toggle('active');
      });

    });

  }

});